import BaseLogModel from '../../../models/BaseLogModel';
import { BaseQuerySingleInputModel } from '../../../models/BaseQueryInputModel';
import { HasuraFilterInputModel } from '../../../models/HasuraFilterInputModel';
import { HasuraOrderByInputModel } from '../../../models/HasuraOrderByInputModel';
import { HasuraRefModel } from '../../../models/HasuraRefModel';
import MasterDataCountry, {
  MasterDataCountryFilterInput,
  MasterDataCountryOrderByInput,
} from '../../countries/models/MasterDataCountry';
import MasterDataLanguage, {
  MasterDataLanguageFilterInput,
  MasterDataLanguageOrderByInput,
} from '../../languages/models/MasterDataLanguage';
import User, { UserFilterInput } from '../../users/models/User';
import Widget from '../../widgets/interfaces/Widget';
import MasterDataBoutique, {
  MasterDataBoutiqueFilterInput,
  MasterDataBoutiqueOrderByInput,
} from './MasterDataBoutique';

export enum BoutiquesView {
  Table = 'table',
  Grid = 'grid',
}

export interface BoutiqueCoverImage {
  unsplashId?: string;
  unsplashLink?: string;
  unsplashUserName?: string;
  unsplashUserUrl?: string;
  urlFull: string;
  urlRegular: string;
}

export default interface Boutique extends BaseLogModel {
  _id: string;
  admins: User[];
  boutique?: MasterDataBoutique;
  country?: MasterDataCountry;
  coverImage?: BoutiqueCoverImage;
  language?: MasterDataLanguage;
  name: string;
  staffMembers: User[];
  widgets?: Widget[];
}

// Hasura GraphQL resolvers

export interface BoutiqueQuerySingleInput extends BaseQuerySingleInputModel {}

export interface BoutiqueInsertInput
  extends Omit<Boutique, 'admins' | 'boutique' | 'country' | 'language' | 'staffMembers'> {
  adminIds?: User['_id'][];
  boutiqueId?: MasterDataBoutique['_id'];
  countryId?: MasterDataCountry['_id'];
  languageId?: MasterDataLanguage['_id'];
  staffMemberIds?: User['_id'][];
}

export interface BoutiqueUpdateInput extends Partial<Omit<BoutiqueInsertInput, '_id'>> {}

export type BoutiqueRef = HasuraRefModel<Boutique>;

export interface BoutiqueFilterInput extends HasuraFilterInputModel<Boutique> {
  admins?: UserFilterInput;
  boutique?: MasterDataBoutiqueFilterInput;
  country?: MasterDataCountryFilterInput;
  language?: MasterDataLanguageFilterInput;
  staffMembers?: UserFilterInput;
}

export interface BoutiqueOrderByInput extends HasuraOrderByInputModel<Boutique> {
  boutique?: MasterDataBoutiqueOrderByInput;
  country?: MasterDataCountryOrderByInput;
  language?: MasterDataLanguageOrderByInput;
}
